export default __webpack_public_path__ + "static/media/kashmir.91a929bf.jpg";